import { Button, styled, Typography } from '@mui/material';

import { ACCEPTED_IMAGE_FORMAT } from '~configs';

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

type Props = {
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  accept?: string;
  multiple?: boolean;
  isDisabled?: boolean;
};

export const InputPhotoUpload: React.FC<Props> = ({
  onChange,
  accept = ACCEPTED_IMAGE_FORMAT,
  multiple = false,
  isDisabled = false,
}) => (
  <Button
    component={'label'}
    color={'info'}
    size={'small'}
    sx={{ border: '1px solid' }}
    disabled={isDisabled}
  >
    <Typography variant={'body2'}>Upload photos</Typography>
    <VisuallyHiddenInput
      multiple={multiple}
      type={'file'}
      onChange={onChange}
      accept={accept}
    />
  </Button>
);
